import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types';
import Modal from 'react-bootstrap4-modal';
import { PulseLoader } from 'halogenium';
import { TableType } from '../../Enum/TableType';


class ChangeTableModalPortal extends React.Component {
    constructor(props) {
        super(props);
        this.portalDomId = 'change-table-modal-portal';
        if ($('#'+this.portalDomId).length == 0) {
            $('body').prepend(`<div id="${this.portalDomId}"></div>`)
        }
        this.portalRoot = document.getElementById(this.portalDomId);
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class ChangeTableModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changeToTableId: "",
            isLoading: false
        }
    }
    onClose() {
        this.props.onClose()
    }
    getTableStatus(table) {
        if (this.props.app.state.sessions != null) {
            let tableSession = this.getTableSession(table)
            if (tableSession != null) {
                if (tableSession.bill_id != null) {
                    return 2 // Billing
                } else {
                    return 1 // Sitting
                }
            }
        }
        return 0 // Free table
    }
    onChangeTableClicked() {
        if (!this.state.changeToTableId) {
            alert(lang.to_empty_msg)
            return
        }

        this.setState({isLoading: true})
        $.ajax({
            url     : `/merchant/tables/change_table`,
            type    : 'post',
            data    : {
                from    : this.props.table.id,
                to      : this.state.changeToTableId,
                table_session_id: this.props.tableSessionId || (this.props.app.state.currentSession && this.props.app.state.currentSession.id),
            },
            success : (res) => {
                // alert(lang.change_table_success)
                this.setState({isLoading: false})
                this.props.onClose()
            }
        })
    }
    getTableSession(table) {
        return this.props.app.state.sessions.find(elem => { return elem.table_id == table.id; })
    }
    getTableListing() {
        const isMultiTableSession = this.props.app.isMerchantHasFeature('multi_table_session_per_table')
        let tables = this.props.tables.filter(t => t.status == "active")
        tables.sort((a, b) => {
            return (a.name + "").localeCompare((b.name + ""), undefined, {numeric: true, sensitivity: 'base'})
        })
        let options = tables.map(table => {
            const tableStatus = isMultiTableSession ? 0 : this.getTableStatus(table)
            let tableStatusString = tableStatus != 0 ? " (" + lang.active + ")" : ""
            if ((table.table_type_bitwise & TableType.DINE_IN) > 0 || table.table_type_bitwise == 3) {
                return <option value={table.id} key={table.id} disabled={!isMultiTableSession && tableStatus != 0}>
                    {lang.table} {table.name} {tableStatusString}
                </option>
            }
        })

        // Add first empty element
        options.unshift(<option value="" key={-1}></option>)

        return <select className="form-control" value={this.state.changeToTableId} onChange={(e) => this.setState({ changeToTableId: e.target.value })}>
            {options}
        </select>
    }
    render() {
        if (!this.props.visible) {
            return <div></div>
        }
        return (
            <ChangeTableModalPortal>
                <Modal visible={true} fade={false}>
                    <div className="modal-header">
                        <h5 className="modal-title">{lang.change_table}</h5>
                    </div>
                    <div className="modal-body">
                        <div>
                            {lang.from + " " + lang.table} {this.props.table.name}
                        </div>
                        <div className="mt-2">
                            {lang.change_to}
                            <div>{
                                    this.state.isLoading ?
                                    <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                                    this.getTableListing()
                            }</div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" onClick={() => { this.onClose() }}>
                            {lang.close}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={this.onChangeTableClicked.bind(this)}>
                            {lang.change_table}
                        </button>
                    </div>
                </Modal>
            </ChangeTableModalPortal>
        );
    }
}
ChangeTableModal.propTypes = {
    app: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired
}

export default ChangeTableModal;